import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import SingleBatchComponent from "../components/batches/SingleBatchComponent";

const SingleBatchPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Batch Details"
        routes={[
          { title: "Home", path: "/" },
          { title: "Batches", path: "/batches" },
        ]}
      />
      <SingleBatchComponent />
    </>
  );
};
export default SingleBatchPage;
